/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Tab_AuditInputs */

const cs_gdpr_tab_audit = /** @type {(inputs: Gdpr_Tab_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditní log`)
};

const en_gdpr_tab_audit = /** @type {(inputs: Gdpr_Tab_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit log`)
};

/**
* | output |
* | --- |
* | "Audit log" |
*
* @param {Gdpr_Tab_AuditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_tab_audit = /** @type {((inputs?: Gdpr_Tab_AuditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Tab_AuditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_tab_audit(inputs)
	return cs_gdpr_tab_audit(inputs)
});